import { Fragment } from "react";
import { Company } from "../../../core/models/company.model";
import LinkButton from "../../buttons/LinkButton/LinkButton";

const CompanyWebsiteInfo = (props: { company: Company | undefined}) => {
  const { company } = props;

  if (!company?.website) {
    return <Fragment />;
  }

  return (
    <div className="info-text">
      <LinkButton
        onClick={() => {}}
        styleClass="link-container"
        textClass="small"
        valueLink={company?.website}
        valueText={company?.website}
      />
    </div>
  );
}

export default CompanyWebsiteInfo;